import React from "react";
import moment from "moment";

class Experience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatDate(date) {
    return moment(date).format("MMMM YYYY");
  }

  render() {
    const jobs = this.props.jobs;
    return (
      <div className="experience">
        {jobs.map((job, index) => {
          const endDate =
            job.endDate === "Present"
              ? job.endDate
              : this.formatDate(job.endDate);
          const startDate = this.formatDate(job.startDate);

          return (
            <div key={index}>
              {/* some special formatting for printing */}
              {/* {index === jobs.length - 1 ? <br /> : null} */}
              <h2
              // className={index === jobs.length - 1 ? "page_break_before" : ""}
              >
                {job.companyName}{" "}
                <span className="job__country">- {job.country}</span>
              </h2>
              <div>
                <span className="job__title">
                  {job.title} ({startDate} - {endDate})
                </span>
              </div>
              <ul>
                {job.responsibilities.map((responsibility, respIndex) => {
                  return <li key={respIndex}>{responsibility}</li>;
                })}
              </ul>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Experience;
